/**
 * Eventos entre partes del portal que no se conocen.
 *
 * `BANDEJA_CAMBIO` lo emite el Layout cuando el contador del sidebar ve que
 * cambió lo asignado a quien mira —le asignaron una, se la reasignaron a otro—
 * y lo escucha la bandeja para refrescar su lista EN ESE MOMENTO.
 *
 * Hasta el 28-set-2026 eran dos sondeos independientes: el contador cada 10 s
 * (que es el que suena y mueve el badge) y la lista cada 15 s. Sonaba «te
 * asignaron una» y la bandeja seguía sin mostrarla hasta su propio turno. Con
 * el evento, el sonido y la fila llegan juntos, y la lista no tiene que
 * sondear más seguido: el contador es la consulta barata.
 */
export const BANDEJA_CAMBIO = 'pgh:bandeja-cambio'

/**
 * `MENSAJE_NUEVO` lo emite el Layout cuando el contador ve que un cliente
 * escribió —en lo de quien mira: lo suyo para el asesor, todo para
 * supervisión—, y lo escuchan la bandeja y En vivo para traer la lista EN ESE
 * MOMENTO: sonaba el aviso y la fila con el número verde aparecía recién en el
 * sondeo propio de la lista, hasta 20 s después (06-oct-2026).
 */
export const MENSAJE_NUEVO = 'pgh:mensaje-nuevo'

/**
 * `EXPEDIENTE_LISTO` lo emite el Layout cuando el contador ve que un
 * expediente de quien mira quedó completo (03-nov-2026), y lo escucha «Mis
 * expedientes» para traer la lista con el aviso, no en su próximo sondeo.
 */
export const EXPEDIENTE_LISTO = 'pgh:expediente-listo'
